import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { raffleApi } from "../lib/api";
import {
  ArrowRight,
  Ticket,
  Clock,
  TrendingUp,
  Gift,
  Trophy,
} from "lucide-react";
import { Progress } from "../components/ui/progress";
import { Footer } from "../components/ui/footer";
import { HeaderLanding } from "../components/ui/header-landings";
import { Header } from "@radix-ui/react-accordion";

export default function HomePage() {
  const [raffles, setRaffles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRaffles = async () => {
      try {
        const response = await raffleApi.getAll();
        setRaffles(response.data);
      } catch (error) {
        console.error("Error fetching raffles:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchRaffles();
  }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="home-page">
      {/* Header */}
      <HeaderLanding />

      {/* Hero Section */}
      <section className="border-b-2 border-black" data-testid="hero-section">
        <div className="px-4 sm:px-8 max-w-7xl mx-auto py-16 md:py-24">
          <div class="flex min-h-[480px] flex-col items-center justify-center gap-6 rounded-xl bg-cover bg-center p-8 text-center text-white bg-hero-pattern">
            <h1 class="text-3xl uppercase font-extrabold tracking-tighter sm:text-5xl md:text-5xl">
              ¡Gana premios increíbles!
            </h1>
            <p class="max-w-2xl text-base text-white/80 sm:text-lg">
              Participa en nuestros sorteos exclusivos. Selecciona tus números
              de la suerte y prepárate para ganar.
            </p>
            <a
              href="#sorteos"
              className="inline-flex items-center gap-2 bg-[#FF3333] text-white font-bold uppercase tracking-wider border-2 border-black px-6 py-3 shadow-[4px_4px_0_0_#000000] hover:translate-y-[2px] hover:translate-x-[2px] hover:shadow-[2px_2px_0_0_#000000] active:shadow-none active:translate-y-[4px] active:translate-x-[4px] transition-all"
            >
              Ver Sorteos <ArrowRight className="w-5 h-5" />
            </a>
          </div>
          <div class="px-4 py-12">
            <h2 class="mb-8 text-center uppercase text-3xl font-bold text-slate-900 dark:text-white">
              ¿Cómo funciona?
            </h2>
            <p class="my-8 text-center text-slate-600 dark:text-slate-400">
              En Zeitex Sorteos, la legalidad y la emoción van de la mano. Todos
              nuestros sorteos se realizan con base en los resultados oficiales
              de la Lotería Nacional para la Asistencia Pública y SorteosTec
              Efectivo. De esta manera, garantizamos total transparencia y
              seguridad en cada dinámica.
            </p>
            <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
              <div class="flex flex-col items-center gap-4 rounded-lg border border-slate-200 dark:border-slate-800 bg-white dark:bg-background-dark p-6 text-center">
                <div class="flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 text-primary">
                  <Gift className="w-8 h-8" />
                </div>
                <h3 class="text-lg font-bold text-slate-900 dark:text-white">
                  Elige tu sorteo
                </h3>
                <p class="text-sm text-slate-600 dark:text-slate-400">
                  Navega por nuestra selección de increíbles premios.
                </p>
              </div>
              <div class="flex flex-col items-center gap-4 rounded-lg border border-slate-200 dark:border-slate-800 bg-white dark:bg-background-dark p-6 text-center">
                <div class="flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 text-primary">
                  <Ticket className="w-8 h-8" />
                </div>
                <h3 class="text-lg font-bold text-slate-900 dark:text-white">
                  Participa
                </h3>
                <p class="text-sm text-slate-600 dark:text-slate-400">
                  Consigue tus boletos para tener la oportunidad de ganar.
                </p>
              </div>
              <div class="flex flex-col items-center gap-4 rounded-lg border border-slate-200 dark:border-slate-800 bg-white dark:bg-background-dark p-6 text-center">
                <div class="flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 text-primary">
                  <Trophy className="w-8 h-8" />
                </div>
                <h3 class="text-lg font-bold text-slate-900 dark:text-white">
                  Gana
                </h3>
                <p class="text-sm text-slate-600 dark:text-slate-400">
                  Anunciamos a los afortunados ganadores en nuestras redes
                  sociales.
                </p>
              </div>
            </div>
            <h2 class="my-8 text-center uppercase text-2xl font-bold text-slate-900 dark:text-white">
              ¿Cómo ganar en Zeitex Sorteos?
            </h2>
            <p class="mt-4 text-center text-slate-600 dark:text-slate-400">
              Es muy sencillo: resultan ganadores los boletos cuyas cifras
              coincidan con el Premio Mayor de la Lotería Nacional o los
              resultados de SorteosTec.
            </p>
            <p class="mt-4 text-center text-slate-600 dark:text-slate-400">
              <span class="font-bold">Transparencia garantizada:</span>{" "}
              Resultados vinculados a sorteos oficiales.
            </p>
            <p class="mt-2 text-center text-slate-600 dark:text-slate-400">
              <span class="font-bold">Premios en efectivo:</span> Participa y
              conviértete en nuestro próximo ganador.
            </p>
            <p class="mt-2 text-center text-slate-600 dark:text-slate-400">
              <span class="font-bold">Fechas actualizadas:</span> Consulta
              nuestro calendario oficial en la web para no perderte ninguna
              oportunidad.
            </p>
            <p class="mt-4 text-center text-slate-600 dark:text-slate-400">
              <span class="font-bold">
                ¡Compra tus boletos hoy y pon a prueba tu suerte con los sorteos
                más confiables!
              </span>
            </p>
          </div>
        </div>
      </section>

      {/* Raffles Section */}
      <section id="sorteos" className="py-16 md:py-24 bg-[#F3F4F6]">
        <div className="px-4 sm:px-8 max-w-7xl mx-auto">
          <div className="mb-12">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#FF3333] mb-2">
              Sorteos activos
            </p>
            <h2 className="text-3xl sm:text-4xl font-bold tracking-tight">
              PARTICIPA AHORA
            </h2>
          </div>

          {loading ? (
            <div className="flex items-center justify-center py-16">
              <div className="animate-spin rounded-full h-12 w-12 border-4 border-black border-t-transparent"></div>
            </div>
          ) : raffles.length === 0 ? (
            <div className="bg-white border-2 border-black p-12 text-center">
              <Ticket className="w-16 h-16 mx-auto mb-4 text-[#D1D5DB]" />
              <h3 className="text-2xl font-bold mb-2">
                No hay sorteos activos
              </h3>
              <p className="text-[#4B5563]">
                Vuelve pronto para ver nuevos sorteos
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {raffles.map((raffle) => {
                const progress =
                  (raffle.sold_tickets / raffle.total_tickets) * 100;
                const daysLeft = Math.max(
                  0,
                  Math.ceil(
                    (new Date(raffle.end_date) - new Date()) /
                      (1000 * 60 * 60 * 24),
                  ),
                );

                return (
                  <div
                    key={raffle.id}
                    className="bg-white border-2 border-black shadow-[8px_8px_0_0_#000000] hover:-translate-y-1 hover:shadow-[12px_12px_0_0_#000000] transition-all"
                    data-testid="raffle-card"
                  >
                    <div className="aspect-video overflow-hidden border-b-2 border-black">
                      <img
                        src={raffle.image_url}
                        alt={raffle.title}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="p-6 space-y-4">
                      <h3 className="text-2xl font-bold">{raffle.title}</h3>
                      <p className="text-[#4B5563] text-sm line-clamp-2">
                        {raffle.description}
                      </p>

                      <div className="space-y-2">
                        <div className="flex justify-between text-sm">
                          <span className="font-bold">
                            {raffle.sold_tickets}/{raffle.total_tickets} boletos
                          </span>
                          <span className="text-[#4B5563]">
                            {progress.toFixed(0)}%
                          </span>
                        </div>
                        <Progress
                          value={progress}
                          className="h-2 bg-[#D1D5DB]"
                        />
                      </div>

                      <div className="flex items-center justify-between text-sm">
                        <div className="flex items-center gap-1 text-[#4B5563]">
                          <Clock className="w-4 h-4" />
                          <span>{daysLeft} días</span>
                        </div>
                        <div className="flex items-center gap-1 font-bold text-[#FF3333]">
                          <TrendingUp className="w-4 h-4" />
                          <span>${raffle.ticket_price} MXN</span>
                        </div>
                      </div>

                      <Link
                        to={`/sorteo/${raffle.id}`}
                        className="block w-full text-center bg-[#0A0A0A] text-white font-bold uppercase tracking-wider border-2 border-black px-6 py-3 shadow-[4px_4px_0_0_#FF3333] hover:translate-y-[2px] hover:translate-x-[2px] hover:shadow-[2px_2px_0_0_#FF3333] transition-all"
                        data-testid="view-raffle-button"
                      >
                        Participar
                      </Link>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
}
